import { useEffect, useState } from 'react';
import { companyScopeService } from '../scripts/companyScope';

export function useShowAllCompanies() {
  const [data, setData] = useState<boolean>(companyScopeService.showAllCompaniesValue);

  useEffect(() => {
    const subscription = companyScopeService.showAllCompanies.subscribe({
      next: (value) => setData(value),
      error: (err) => console.error('Error in showAllCompanies subscription:', err)
    });

    return () => subscription.unsubscribe();
  }, []);

  return [data, companyScopeService.setShowAllCompanies] as const;
}
